import PageHeader from "@ui/components/header/PageHeader";
import { PageContainer, PageContent } from "@ui/components/wraper";
import React from "react";
import { useReportsFilter } from "./hooks/useReportsFilter";
import { useReportsData } from "./hooks/useReportsData";
import { TemperatureTable } from "./components/TemperatureTable";
import { ReportFilters } from "./components/ReportFilters";
import { Alert, Box, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
const ReportsPage = () => {
    const { t } = useTranslation(["form", "validation", "common"]);
    const { control, resetFilters, selectedNodes, nodeStatus, interval, showBy, fromDate, toDate, nodeOptions, nodesLoading, handleNodesSearch, handleNodesListboxScroll, loadNextNodesPage, } = useReportsFilter();
    const { temperatureData, reportColumnNodes, loading, error, downloadExcelReport, downloadPdfReport, refetchData, clearData, } = useReportsData({
        selectedNodes,
        nodeStatus,
        fromDate,
        toDate,
        interval,
        showBy,
    });
    return (React.createElement(PageContainer, null,
        React.createElement(PageHeader, { title: t("common:pages.reports") }),
        React.createElement(PageContent, null,
            React.createElement(ReportFilters, { control: control, nodeOptions: nodeOptions, nodesLoading: nodesLoading, onNodesSearch: handleNodesSearch, onNodesListboxScroll: handleNodesListboxScroll, onNodesNeedMore: loadNextNodesPage, onSearch: refetchData, onClear: () => {
                    resetFilters();
                    clearData();
                }, loading: loading }),
            error && (React.createElement(Alert, { severity: "error", sx: { mb: 2 } }, error)),
            loading ? (React.createElement(Box, { sx: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    py: 8,
                } },
                React.createElement(CircularProgress, { size: 40 }),
                React.createElement(Typography, { variant: "body2", color: "text.secondary", sx: { mt: 2 } }, "Loading report data..."))) : (
            /* Table Section */
            React.createElement(TemperatureTable, { selectedNodes: selectedNodes, gridColumnNodes: reportColumnNodes, temperatureData: temperatureData, onDownloadExcel: downloadExcelReport, onDownloadPdf: downloadPdfReport })))));
};
export default ReportsPage;
